<form (ngSubmit)="onSubmit(EditPartnerUserForm)" #EditPartnerUserForm="ngForm">
    <p-dialog [(visible)]="displayInactivateInput" [modal]="true" [positionTop]="50" [maximizable]="true"
      (onHide)="dialogClose()" (onShow)="dialogOpen()"
      [contentStyle]="{'min-width':'600px'}">  
      <p-header>
        <b>Deactivate Partnership User</b>
      </p-header>
      <div class="ui-grid ui-grid-responsive formcontainer custom-dialog-content">
        <p-fieldset>
          <p-header class="fieldset-header">Update Primary Contact</p-header>             
            <div class="formgroup">
              <div class="ui-grid-row">
                  <div class="ui-grid-col-12">
                    <label for="popup-heading">Are you sure you want to Inactivate this user from your relationship?
                      <br />To remove the Primary Contact and their access to your assets, you must select a new Primary Contact.
                    </label>
                  </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <app-change-primary-contact 
                    [PersonId]="partnerDetails.PartnerUser.Person.PersonId"
                    [DisplayRelationshipIds]="[relationshipData.RelationshipXrefId]"
                    (RelationshipAndContactId)="mapRelationshipAndContactId($event)"
                    (IsPrimaryContactReady)="checkIsPrimaryContactReady($event)" >
                  </app-change-primary-contact>
                </div>
              </div>
            </div>
        </p-fieldset>
      </div>
      <p-footer>
        <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="dialogClose()"></button>
        <button pButton type="submit" label="{{processing ? 'Processing' : 'Remove User'}}"
          [disabled]="!EditPartnerUserForm.form.valid || processing || !isPrimaryContactSelected"></button>        
      </p-footer>
    </p-dialog>
  </form>
  